'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLocalConvenienceStore = function MdLocalConvenienceStore(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.6 20v-8.4h-1.6v3.4h-1.6v-3.4h-1.8v5h3.4v3.4h1.6z m-8.2-3.4v-5h-5v1.8h3.2v1.6h-3.2v5h5v-1.6h-3.4v-1.8h3.4z m13.2-5h5v21.8h-13.2v-6.8h-6.8v6.8h-13.2v-21.8h5v-5h23.2v5z' })
        )
    );
};

exports.default = MdLocalConvenienceStore;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/local-convenience-store.js
// module id = 2497
// module chunks = 0